import type { CaseOverlayTab } from '@/overlays/CaseOverlay/types';

export const classes = {
  column: 'flex flex-col h-full min-w-0 grow overflow-hidden px-[26px]',
  tabsBlock: 'w-full flex flex-col flex-1 h-full',
  tabBody: 'flex-1 min-h-0 overflow-auto pb-[26px]',
  adornment:
    'rounded-full px-2 py-0.5 ml-2 bg-brand-accent text-white text-[11px] font-bold place-center select-none dark:bg-brand-accent-dark',
};

export function getDefaultTab(searchParams: URLSearchParams) {
  let overlayTab = searchParams.get('caseOverlayTab');
  if (!overlayTab || !['overview', 'tasks', 'orders'].includes(overlayTab)) {
    overlayTab = 'overview';
  }
  return overlayTab as CaseOverlayTab;
}
